import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-white font-heading text-neutral-900 antialiased" data-id="element-0" data-mp="3fbjbj4ny1vvy">
      <Header data-id="element-1" data-mp="2rk46330veygh" />
      <main data-id="element-2" data-mp="2rlozuqfd2dda">
        <Hero data-id="element-3" data-mp="2rlf6csv3xo2u" />
        <Services data-id="element-4" data-mp="2rit2b37fdqpd" />
        <Process data-id="element-5" data-mp="2mlua4q7bnttt" />
        <Contact data-id="element-6" data-mp="2mmcds7wbdabr" />
      </main>
      <Footer data-id="element-7" data-mp="2mn5aeg1k6jg6" />
    </div>;
}